import { ISiteSectionEntry } from '../../../../contentful/types/ISiteSection';
import { SiteSectionItem } from '../shared/SiteSectionItem';
import { List, SkipContentLink } from './SiteSections.styles';

interface IProps {
	siteSections: ISiteSectionEntry[];
	currentSiteSectionId?: string;
	onSiteSectionIdChange: (id: string) => void;
	collapsed: boolean;
}

export function SiteSections({
	collapsed,
	siteSections,
	currentSiteSectionId,
	onSiteSectionIdChange,
}: IProps) {
	return (
		<List>
			<li className="no-max-width">
				<SkipContentLink href="#main">Skip to content</SkipContentLink>
			</li>
			{siteSections.map((section) => (
				<li key={section.id} className="no-max-width">
					<SiteSectionItem
						siteSection={section}
						onSiteSectionIdChange={onSiteSectionIdChange}
						collapsed={collapsed}
						isCurrent={section.fields.id === currentSiteSectionId}
					/>
				</li>
			))}
		</List>
	);
}
